import React from 'react';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import PencilIcon from 'buyside/svgs/pencil.svg';

import { newResearchUrl } from 'buyside/util/urlHelper';

const SubmitResearchButton = props => {
  const researchButtonOptions = {
    text: 'Submit Research',
    type: BUTTON_TYPES.MAJOR,
    size: BUTTON_SIZES.SMALL,
    icon: PencilIcon,
    url: newResearchUrl(),
    analyticsTag: 'submit-research'
  };
  return <Button {...researchButtonOptions} {...props} />;
};

export default SubmitResearchButton;
